import PropTypes from "prop-types";
// @mui material components
import { Card, Divider, Grid, Icon, Skeleton, Tooltip } from "@mui/material/";

// Kaizen Dashboard components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

import SoftButton from "components/SoftButton";
import dayjs from "dayjs";
import SinDatos from "components/Carteles/SinDatos";
import { useContext, useState } from "react";
import ModalEditarLimites from "./ModalEditarLimites";
import { UserContext } from "context/user";

const daysOfWeek = ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"];
const months = [
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octubre",
  "Noviembre",
  "Diciembre",
];

function EventosCard({ fecha, eventos, loading, handleClickButton, onRefetch }) {
  const [modalEditarLimites, setModalEditarLimites] = useState(false);
  const [selectedMenuItem, setSelectedMenuItem] = useState(null);
  const { user } = useContext(UserContext);

  const eventosDeHoy = eventos.filter(
    (evento) => dayjs(evento.date).format("DD") === dayjs(fecha).format("DD")
  );

  const handleEditarLimites = (evento) => {
    setSelectedMenuItem(evento);
    setModalEditarLimites(true);
  };

  const handleCloseEditarLimites = (shouldRefetch = false) => {
    setModalEditarLimites(false);
    setSelectedMenuItem(null);
    if (shouldRefetch && onRefetch) {
      onRefetch();
    }
  };

  console.log('user', user)


  return (
    <Card
      sx={{
        width: "100%",
        height: "100%",
      }}
    >
      {fecha ? (
        <SoftBox p={2} lineHeight={1.25}>
          <SoftTypography
            variant="h6"
            fontWeight="medium"
            display="flex"
            justifyContent="space-between"
          >
            {loading ? (
              <SoftBox sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                <Skeleton variant="text" width={200} sx={{ fontSize: "1rem" }} />
              </SoftBox>
            ) : (
              <>
                <SoftBox display="flex" alignItems="center">
                  {`${daysOfWeek[dayjs(fecha).day()]}, ${dayjs(fecha).date()} de ${months[dayjs(fecha).month()]
                    } de ${dayjs(fecha).year()}`}
                </SoftBox>
                {user?.sede?.id == 1 && (<SoftBox px={2}>
                  <Tooltip title="Agregar menú al día elegido" placement="top" x>
                    <SoftButton
                      color="uproGreen"
                      circular
                      iconOnly
                      size="medium"
                      onClick={handleClickButton}
                    >
                      <Icon>add</Icon>
                    </SoftButton>
                  </Tooltip>
                </SoftBox>)}
              </>
            )}
          </SoftTypography>
          {/* <SoftTypography variant="h7" color="text" fontWeight="regular">
            {loading ? (
              <SoftBox sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                <Skeleton variant="text" width={100} sx={{ fontSize: "0.5rem" }} />
              </SoftBox>
            ) : eventosDeHoy.length > 0 ? (
              "Tienes Menús para este día"
            ) : (
              "No tienes Menú programados para este día"
            )}
          </SoftTypography> */}
          <Divider />

          <SoftBox
            sx={{
              height: "100%",
              maxHeight: "calc(60vh)",
              overflowY: "auto",
            }}
          >
            {loading ? (
              <SoftBox>
                <Skeleton variant="text" width={"100%"} />
                <Skeleton variant="text" width={"100%"} />
              </SoftBox>
            ) :
              eventosDeHoy.length > 0 ? (
                <SoftBox p={2} display="flex" flexDirection="column">
                  <Grid container display="flex" alignItems="center" justifyContent="space-between">
                    <Grid item display="flex" alignItems="center" xs={user?.sede?.id == 1 ? 5 : 3}>
                      <SoftTypography variant="h7" pl={1} color="text" fontWeight="bold">
                        Menú
                      </SoftTypography>
                    </Grid>
                    <Grid item display="flex" alignItems="center" xs={user?.sede?.id == 1 ? 2 : 2}>
                      <SoftTypography variant="h7" color="text" fontWeight="bold">
                        Turno
                      </SoftTypography>
                    </Grid>
                    {user?.sede?.id == 1 ? (
                      <Grid item display="flex" alignItems="center" xs={4}>
                        <SoftTypography variant="h7" color="text" fontWeight="bold">
                          Límite de reservas
                        </SoftTypography>
                      </Grid>
                    ) : (
                      <>
                        <Grid item display="flex" alignItems="center" xs={2}>
                          <SoftTypography variant="h7" color="text" fontWeight="bold">
                            Límite SP
                          </SoftTypography>
                        </Grid>
                        <Grid item display="flex" alignItems="center" xs={2}>
                          <SoftTypography variant="h7" color="text" fontWeight="bold">
                            Límite TR
                          </SoftTypography>
                        </Grid>
                        <Grid item display="flex" alignItems="center" xs={1}>
                          <SoftTypography variant="h7" color="text" fontWeight="bold">
                            Límite Cent
                          </SoftTypography>
                        </Grid>
                      </>
                    )}
                    <Grid item display="flex" alignItems="center" justifyContent="center" xs={user?.sede?.id == 1 ? 1 : 2}>
                      <SoftTypography variant="h7" color="text" fontWeight="bold">
                        Acciones
                      </SoftTypography>
                    </Grid>
                  </Grid>
                  <Divider />
                  {eventosDeHoy.map((evento, index) => (
                    <Grid
                      key={index}
                      display="flex"
                      alignItems="center"
                      justifyContent="space-between"
                      mt={index === 0 ? 0 : 1}
                      container
                    >
                      <Grid display="flex" alignItems="center" item xs={user?.sede?.id == 1 ? 5 : 3} px={.5}>
                        <SoftBox mr={1} display="flex" alignItems="center">
                          <Tooltip title={evento.type} placement="top">
                            <Icon
                              color={evento.color}
                              sx={{
                                cursor: "pointer",
                              }}
                            >
                              {evento.icon}
                            </Icon>
                          </Tooltip>
                        </SoftBox>
                        <SoftTypography variant="h7" color="text" fontWeight="regular">
                          {evento.title}
                        </SoftTypography>
                      </Grid>
                      <Grid item display="flex" alignItems="center" xs={user?.sede?.id == 1 ? 2 : 2}>
                        <SoftTypography variant="h7" color="text" fontWeight="regular">
                          {evento.turno ? "Turno " + evento.turno : "Sin turno"}
                        </SoftTypography>
                      </Grid>
                      {user?.sede?.id == 1 ? (
                        <Grid item display="flex" alignItems="center" xs={4}>
                          <SoftTypography variant="h7" color="text" fontWeight="regular">
                            {evento.limiteReservas ? evento.limiteReservas : "Sin especificar"}
                          </SoftTypography>
                        </Grid>
                      ) : (
                        <>
                          <Grid item display="flex" alignItems="center" xs={2}>
                            <SoftTypography variant="h7" color="text" fontWeight="regular">
                              {evento.limiteReservasSedeSP ? evento.limiteReservasSedeSP : "Sin especificar"}
                            </SoftTypography>
                          </Grid>
                          <Grid item display="flex" alignItems="center" xs={2}>
                            <SoftTypography variant="h7" color="text" fontWeight="regular">
                              {evento.limiteReservasSedeTR ? evento.limiteReservasSedeTR : "Sin especificar"}
                            </SoftTypography>
                          </Grid>
                          <Grid item display="flex" alignItems="center" xs={1}>
                            <SoftTypography variant="h7" color="text" fontWeight="regular">
                              {evento.limiteReservasSedeC ? evento.limiteReservasSedeC : "Sin especificar"}
                            </SoftTypography>
                          </Grid>
                        </>
                      )}
                      <Grid item xs={user?.sede?.id == 1 ? 1 : 2} display="flex" justifyContent="center" gap={0.5}>
                        {evento?.actionList?.filter(ev => {
                          // Para sede ID 1: mostrar solo "quitar menu del dia" y "ver receta"
                          if (user?.sede?.id == 1) {
                            return ev.tooltip === "Quitar de menú del día" || ev.tooltip === "Ver receta";
                          }
                          // Para sede ID 2: solo mostrar "editar limite"
                          if (user?.sede?.id == 2) {
                            return ev.tooltip === "Editar límite";
                          }
                          // Para otras sedes, mostrar todas las acciones
                          return true;
                        }).map((ev, i) => (
                          <Tooltip key={i} title={ev.tooltip} placement="top">
                            <SoftButton
                              color={ev.btnColor || "uproGreen"}
                              circular
                              iconOnly
                              size="small"
                              onClick={ev.btnIcon === "edit" ? () => handleEditarLimites(evento) : ev.action}
                              disabled={ev.disabled}
                            >
                              <Icon>{ev.btnIcon || "arrow_forward"}</Icon>
                            </SoftButton>
                          </Tooltip>
                        ))}
                      </Grid>
                    </Grid>
                  ))}
                </SoftBox>
              )
                : (
                  <SinDatos />
                )}
          </SoftBox>
        </SoftBox>
      ) : null}
      <ModalEditarLimites
        open={modalEditarLimites}
        onClose={handleCloseEditarLimites}
        menuItem={selectedMenuItem}
        onRefetch={onRefetch}
      />
    </Card>
  );
}

// Setting default values for the props of EventosCard
EventosCard.defaultProps = {
  color: "primary",
  eventos: [],
  usuario: {
    sucursal: {},
    puesto: {},
    user: {},
    localidad: { provincia: {} },
    sucursales: [{}],
  },
  loading: true,
  handleClickButton: () => { },
  onRefetch: () => { },
};

// Typechecking props for the EventosCard
EventosCard.propTypes = {
  fecha: PropTypes.string,
  eventos: PropTypes.array,
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "dark",
    "terraPrimary",
    "terraSecondary",
  ]),
  carrera: PropTypes.object,
  loading: PropTypes.bool,
  handleClickButton: PropTypes.func,
  onRefetch: PropTypes.func,
};

export default EventosCard;
